import { WarningKey } from "@silo/types";
import { AlertIcon } from "../../icons";
import { TooltipDescriptionContent } from "../description";
import { Tooltip, TooltipContent, TooltipOrigin } from "../tooltip";
import { Description } from "./description";

export interface TooltipWarningProps {
  warningKey: WarningKey;
}

export function TooltipWarning({
  warningKey,
}: TooltipWarningProps): JSX.Element {
  return (
    <Tooltip>
      <TooltipOrigin className="flex items-center gap-1">
        <AlertIcon className="w-6 h-6 text-amber-300" />
      </TooltipOrigin>
      <TooltipContent>
        <TooltipDescriptionContent>
          <Description warningKey={warningKey} variant="tooltip" />
        </TooltipDescriptionContent>
      </TooltipContent>
    </Tooltip>
  );
}
